import { useEffect } from 'react'

import * as newrelic from 'common/helpers/new_relic'

interface Order {
  id?: string
  company_vendor?: {
    id?: string
    vendor_name?: string
  }
}

export function useOrderNewRelicUserInfo(selectedOrder: Order | null) {
  // This hook can also be used in private order detail pages
  useEffect(() => {
    if (selectedOrder?.id) {
      newrelic.setUserInfo({
        companyVendorId: selectedOrder?.company_vendor?.id,
        companyVendorName: selectedOrder?.company_vendor?.vendor_name,
        type: 'VENDOR',
        public: true,
      })
    }
  }, [selectedOrder?.id])
}
